import React, { forwardRef } from 'react';

interface ArrowUpProps {
  classes?: string;
  style?: React.CSSProperties;
}

export const ArrowUp = forwardRef<HTMLElement, ArrowUpProps>(({ classes, style = {} }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-chevron-up ${classes || ''}`} style={style}></i>
  );
});

ArrowUp.displayName = 'ArrowUp';